<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Gerenciar Tipos de Fornecimento
      </p>
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-3">
          Unidade:
          <lista-unidades-select
            class="input-new-design"
            v-model="filtros.unidadeSelecionada"
          ></lista-unidades-select>
        </div>
        <div class="col-md-3 q-ml-sm">
          Nome do Tipo:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.nome"
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="aplicarFiltros()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>

        <div class="row items-center col-md-3 q-ml-sm q-mt-lg">
          <q-btn
            color="positive"
            no-caps
            icon="add"
            label="Novo Tipo de Fornecimento"
            style="background-color: #58c16d; border-radius: 8px; color: #666"
            @click="abrirModalCriar"
          />
        </div>
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="tiposFornecimento"
        :loading="carregando"
        dense
        :columns="colunas"
        v-model:pagination="paginacao"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="id"
        hide-pagination
        @request="carregarDados"
      >
        <!-- título da tabela -->
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
          >
            Tipos de Fornecimento
          </span>
        </template>

        <!-- mantém seu slot de no-data -->
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>

        <!-- Template slots para formatação de dados -->
        <template #body-cell-createdAt="props">
          <q-td :props="props">
            {{ formatarData(props.value) }}
          </q-td>
        </template>

        <template #body-cell-updatedAt="props">
          <q-td :props="props">
            {{ formatarData(props.value) }}
          </q-td>
        </template>

        <!-- Ações: Editar e Excluir -->
        <template #body-cell-editar="props">
          <q-td class="text-center">
            <q-btn
              round
              dense
              flat
              color="primary"
              icon="edit"
              @click="abrirModalEditar(props.row)"
            />
          </q-td>
        </template>

        <template #body-cell-excluir="props">
          <q-td class="text-center">
            <q-btn
              round
              dense
              flat
              color="negative"
              icon="delete"
              @click="(deletarDialog = true), (tipoOriginal = { ...props.row })"
            />
          </q-td>
        </template>
      </q-table>

      <div
        v-if="tiposFornecimento.length != 0"
        class="row justify-start q-mt-md"
      >
        <q-pagination
          :disable="carregando"
          v-model="paginacao.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <!-- Modal Criar/Editar -->
    <q-dialog persistent>
      <q-card style="min-width: 500px">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">
            {{
              editando
                ? "Editar Tipo de Fornecimento"
                : "Novo Tipo de Fornecimento"
            }}
          </div>
          <q-space />
          <q-btn icon="close" flat round dense @click="fecharModal" />
        </q-card-section>

        <q-card-section>
          <div class="row q-gutter-md">
            <div class="col-12">
              <q-input
                v-model="formulario.name"
                label="Nome do Tipo *"
                outlined
                :error="!!erros.name"
                :error-message="erros.name"
                @update:model-value="limparErro('name')"
              />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancelar" color="negative" @click="fecharModal" />
          <q-btn
            color="primary"
            :label="editando ? 'Atualizar' : 'Criar'"
            :loading="salvando"
            @click="salvarTipoFornecimento"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog de criação de fornecedor -->
    <dialog-info-design
      :mensagem="
        editando ? 'Editar Tipo de Fornecimento' : 'Novo Tipo de Fornecimento'
      "
      :exibir="modalAberto"
      :showConteudo="true"
      :showCancelar="true"
      @resultado="handleModalResultado"
    >
      <div class="row q-gutter-md">
        <div class="col-12">
          <q-input
            v-model="formulario.name"
            label="Nome do Tipo *"
            outlined
            :error="!!erros.name"
            :error-message="erros.name"
            @update:model-value="limparErro('name')"
          />
        </div>
      </div>
    </dialog-info-design>

    <!-- Dialog de confirmação de exclusão -->
    <dialog-info-design
      mensagem="Deletar Tipo de Fornecimento?"
      subMensagem="Tem certeza que deseja deletar este tipo de fornecimento?"
      :exibir="deletarDialog"
      :showCancelar="true"
      @resultado="excluirTipoConfirmado"
    />
  </q-page>
</template>

<script>
const colunas = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
    sortable: true,
  },

  {
    name: "createdAt",
    label: "Criado em",
    field: "createdAt",
    align: "center",
    sortable: true,
  },

  {
    name: "excluir",
    label: "Excluir",
    field: (row) => row,
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";
import { watchDebounced } from "@vueuse/core";

export default {
  name: "TipoFornecedor",
  components: {
    ListaUnidadesSelect,
    DialogInfoDesign,
  },

  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const deletarDialog = ref(false);

    // Estados reativos
    const carregando = ref(false);
    const salvando = ref(false);
    const modalAberto = ref(false);
    const editando = ref(false);

    // Dados
    const tiposFornecimento = ref([]);
    const tipoOriginal = ref(null);
    const searchTimeout = ref(null);

    // Filtros
    const filtros = ref({
      unidadeSelecionada: null,
      nome: "",
    });

    // Paginação
    const paginacao = ref({
      sortBy: "name",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 0,
    });

    // Formulário
    const formulario = ref({
      name: "",
      description: "",
    });

    // Erros de validação
    const erros = ref({});

    const pagesNumber = computed(() => {
      return Math.ceil(
        paginacao.value.rowsNumber / paginacao.value.rowsPerPage
      );
    });

    // Métodos
    const carregarDados = async (requestProp = {}) => {
      try {
        carregando.value = true;

        // Usar a paginação atual se não foi especificada
        const {
          page = paginacao.value.page,
          rowsPerPage = paginacao.value.rowsPerPage,
        } = requestProp.pagination || {};

        const filtrosApi = {
          page,
          perPage: rowsPerPage,
          vendorId: filtros.value.unidadeSelecionada?.id || null,
          name: filtros.value.nome || null,
        };

        const response = await store.dispatch(
          "gdcStore/getSupplies",
          filtrosApi
        );

        // Adaptar resposta da API
        const dados = response.data;
        if (dados.result) {
          tiposFornecimento.value = dados.result.data || dados.result;
          paginacao.value.rowsNumber =
            dados.result.total || dados.result.length;
        } else if (Array.isArray(dados)) {
          tiposFornecimento.value = dados;
          paginacao.value.rowsNumber = dados.length;
        }

        paginacao.value.page = page;
        paginacao.value.rowsPerPage = rowsPerPage;
      } catch (error) {
        console.error("Erro ao carregar tipos de fornecimento:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao carregar dados",
          position: "bottom",
        });
      } finally {
        carregando.value = false;
      }
    };

    const aplicarFiltros = () => {
      paginacao.value.page = 1;
      carregarDados();
    };

    const limparFiltros = () => {
      filtros.value = {
        unidadeSelecionada: null,
        nome: "",
      };
      aplicarFiltros();
    };

    const abrirModalCriar = () => {
      editando.value = false;
      formulario.value = {
        name: "",
        description: "",
      };
      erros.value = {};
      modalAberto.value = true;
    };

    const abrirModalEditar = (tipo) => {
      editando.value = true;
      tipoOriginal.value = { ...tipo };
      formulario.value = {
        name: tipo.name || "",
        description: tipo.description || "",
      };
      erros.value = {};
      modalAberto.value = true;
    };

    const fecharModal = () => {
      modalAberto.value = false;
      editando.value = false;
      tipoOriginal.value = null;
      formulario.value = {
        name: "",
        description: "",
      };
      erros.value = {};
    };

    const validarFormulario = () => {
      erros.value = {};

      if (!formulario.value.name || formulario.value.name.trim() === "") {
        erros.value.name = "Nome é obrigatório";
      }

      return Object.keys(erros.value).length === 0;
    };

    const limparErro = (campo) => {
      if (erros.value[campo]) {
        delete erros.value[campo];
      }
    };

    const handleModalResultado = async (resultado) => {
      if (resultado) {
        salvarTipoFornecimento();
      } else {
        fecharModal();
      }
    };

    const salvarTipoFornecimento = async () => {
      if (!validarFormulario()) {
        return;
      }

      try {
        salvando.value = true;

        const dadosParaEnvio = {
          name: formulario.value.name.trim(),
          description: formulario.value.description?.trim() || "",
        };

        if (editando.value) {
          await store.dispatch("gdcStore/atualizarSupply", {
            supplyId: tipoOriginal.value.id,
            supplyData: dadosParaEnvio,
          });

          quasar.notify({
            type: "positive",
            message: "Tipo de fornecimento atualizado com sucesso!",
            position: "bottom",
          });
        } else {
          await store.dispatch("gdcStore/criarSupply", dadosParaEnvio);

          quasar.notify({
            type: "positive",
            message: "Tipo de fornecimento criado com sucesso!",
            position: "bottom",
          });
        }

        fecharModal();
        carregarDados();
      } catch (error) {
        console.error("Erro ao salvar tipo de fornecimento:", error);

        // Verificar se há erros de validação do servidor
        if (error.response?.data?.errors) {
          const serverErrors = error.response.data.errors;
          Object.keys(serverErrors).forEach((campo) => {
            erros.value[campo] = Array.isArray(serverErrors[campo])
              ? serverErrors[campo][0]
              : serverErrors[campo];
          });
        } else {
          quasar.notify({
            type: "negative",
            message: "Erro ao salvar tipo de fornecimento",
            position: "bottom",
          });
        }
      } finally {
        salvando.value = false;
      }
    };

    const excluirTipoConfirmado = async (resultado) => {
      deletarDialog.value = false;
      if (resultado) {
        try {
          await store.dispatch("gdcStore/excluirSupply", {
            supplyId: tipoOriginal.value.name,
          });

          quasar.notify({
            type: "positive",
            message: "Tipo de fornecimento excluído com sucesso!",
            position: "bottom",
          });

          carregarDados();
        } catch (error) {
          console.error("Erro ao excluir tipo de fornecimento:", error);
          quasar.notify({
            type: "negative",
            message: "Erro ao excluir tipo de fornecimento",
            position: "bottom",
          });
        }
      }
    };

    const formatarData = (data) => {
      if (!data) return "-";
      return new Date(data).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    // Lifecycle
    onMounted(() => {
      carregarDados();
    });

    watch(
      () => paginacao.value.page,
      () => {
        carregarDados();
      }
    );

    watchDebounced(
      () => filtros.value,
      () => {
        aplicarFiltros();
      },
      { debounce: 1500, deep: true }
    );

    return {
      // Estados
      carregando,
      salvando,
      modalAberto,
      editando,

      // Dados
      tiposFornecimento,
      filtros,
      paginacao,
      formulario,
      erros,
      colunas,
      searchTimeout,
      pagesNumber,

      // Métodos
      carregarDados,
      aplicarFiltros,
      limparFiltros,
      abrirModalCriar,
      abrirModalEditar,
      fecharModal,
      validarFormulario,
      limparErro,
      salvarTipoFornecimento,
      excluirTipoConfirmado,
      formatarData,
      deletarDialog,
      tipoOriginal,
      handleModalResultado,
    };
  },
};
</script>

<style scoped>
.custom-table {
  box-shadow: none;
}

.custom-table .q-table__top,
.custom-table .q-table__bottom {
  border: none;
}

.custom-table thead tr:first-child th {
  background-color: #f3f4f6;
  font-weight: 600;
  color: #374151;
}

.custom-table tbody tr:hover {
  background-color: #f9fafb;
}
</style>
